const timesheetUpdatedListeners = new Set();

export const emitTimesheetUpdated = (payload = {}) => {
  timesheetUpdatedListeners.forEach((listener) => {
    try {
      listener(payload);
    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.error("timesheetUpdated listener error", error);
      }
    }
  });
};

export const subscribeTimesheetUpdated = (callback) => {
  if (typeof callback !== "function") {
    return () => {};
  }

  timesheetUpdatedListeners.add(callback);

  return () => {
    timesheetUpdatedListeners.delete(callback);
  };
};
